import cn from 'classnames';
import { FC, PropsWithChildren, ReactNode } from 'react';

import s from './OverlayMessage.module.css';

export type OverlayMessageProps = PropsWithChildren<{
  title?: string;
  message?: string;
  icon?: ReactNode;
  visible?: boolean;
  type?: 'default' | 'success' | 'error';
}>;

const OverlayMessage: FC<OverlayMessageProps> = ({
  title,
  message,
  icon,
  type,
  children,
  visible,
}) => {
  return (
    <div className={cn(s.root, s[type || 'default'], { [s.visible]: visible })}>
      {icon}
      {title && <span className={s.title}>{title}</span>}
      {message && <span className={s.message}>{message}</span>}
      {children && <span className={s.children}>{children}</span>}
    </div>
  );
};

export default OverlayMessage;
